export const state = {
  isOnboarding: false,
  isOnboardingEnabled: false,
};

export const mutations = {
  setIsOnboarding(state, value) {
    state.isOnboarding = value;
  },
};
